import { ITooltipParams } from "ag-grid-community";

export function Tooltip({ value }: ITooltipParams) {
  return (
    <div className={"m-2 p-2 bg-white border-2 border-blue-500"}>{value}</div>
  );
}
